export const preferredLanguage: Array<object> = [
    {
        language: 'en-US',
        map: 'usa-english'
    },
    {
        language: 'en-PR',
        map: 'pr-english'
    },
    {
        language: 'es-PR',
        map: 'pr-spanish'
    },
    {
        language: 'en-CA',
        map: 'ca-english'
    },
    {
        language: 'fr-CA',
        map: 'ca-french'
    },
    {
        language: 'es-MX',
        map: 'mx-spanish'
    },
    {
        language: 'en-MX',
        map: 'mx-english'
    }
];
